define('commons/json-to-html-converter',['jquery', 'utils/application-data'], function($, applicationData) {
    /**
     * Templating engine JSON -> HTML with expression parsing if needed (kind of EL but much much...worse).
     */
    var JsonToHtmlConverter = function() {
        
        this.CONSTANTS = (function() {
            var privateConstants = {
                /** Matches "${value} */
                'EXPRESSION_REGEX': /\$\{\w+(?:\.\w+)*\}/g,
                /** Matches '${' and '}' */
                'EXPRESSION_WRAPPER_REGEX': /^\$\{|\}$/g,
                'IMG_PATH_PREFIX' : '/resources/img',
                'IMG_PATH_SUFFIX' : '.png?v=' + applicationData.version
            };
    
            return {
               get: function(name) { return privateConstants[name]; }
           };
        })();
    };
    
    /**
     * Converts the given templates into their corresponding HTML nodes.
     * The <code>data</code> parameter is optional. If provided it'll be used to parse expressions in the templates.
     * Parsable expressions are in the form : ${beanAttr} and will be replaced by <code>data.beanAttr</code>.
     * If not provided templates are rendered "unchanged".
     * @param templates Array of JSON HTML templates...yeah
     * @param rootNodeSelector Selector for the root node
     * @param data Array containing all data
     * @param $dataWrapperNode Wrapper node for each data, e.g. TR for a table
     * @param extra JSON containing extra attributes (common for all nodes)
     * @returns Corresponding HTML nodes 
     */
    JsonToHtmlConverter.prototype.convert = function(templates, rootNodeSelector, data, $dataWrapperNode, extra){
        /** JSON objects */
        var dataObj = typeof data === 'string' ? data && $.parseJSON(data) : data;
        var templatesObj = typeof templates === 'string' ? $.parseJSON(templates) : templates; 
        var $rootNode = $(rootNodeSelector);
        $rootNode.empty();
        
        // data provided => need to replace expressions
        if(dataObj){
            for (var i = 0, data; data = dataObj[i]; i++) {
                var $clone = $dataWrapperNode.clone();
                // Set the object id into the wrapper node
                var objectId = this._parseTemplate('${id}', data, extra);
                if(typeof objectId !== "undefined"){
                    $clone.attr('data-object-id', objectId);
                }
                $rootNode.append($clone);
                this._convertTemplate(templatesObj, $clone , data, extra);
            } 
        }
        // basic rendering
        else{
            if($dataWrapperNode){
                $rootNode.append($dataWrapperNode);
            }else{
                $dataWrapperNode = $rootNode;
            }
            this._convertTemplate(templatesObj, $dataWrapperNode, null, extra);
        }
        return $rootNode;
    };
    
    /**
     * Converts a particular template to its HTML node, using data parsing if necessary.
     * @param templateObj The JSON template
     * @param $root The root node
     * @param dataObj The optional data object
     * @param extra JSON containing extra attributes (common for all nodes)
     * @returns htmlNodes Result node to be appended
     */
    JsonToHtmlConverter.prototype._convertTemplate = function(templateObj, $root, dataObj, extra){
    	if (typeof templateObj === 'function') {
    		this._convertTemplate(templateObj(dataObj, extra), $root, dataObj, extra);
    	} else if(Array.isArray(templateObj)){
            for (var i = 0, template; template = templateObj[i]; i++){
                this._convertTemplate(template, $root, dataObj, extra);
            }
        } else{
            var $node;
            switch (templateObj.nodeType) {
                case 'div':
                    $node = $('<div></div>');
                    break;
                case 'img':
                    $node = $('<img/>');
                    if(!templateObj.src){
                        throw 'src attribute is mandatory for a IMG node type';
                    }
                    $node.attr('src', this.CONSTANTS.get('IMG_PATH_PREFIX') + this._parseTemplate(templateObj.src, dataObj, extra) + this.CONSTANTS.get('IMG_PATH_SUFFIX'));
                    break;
                case 'a':
                    if(!templateObj.href){
                        throw 'href attribute is mandatory for a LINK node type';
                    }
                    var hrefVal = this._parseTemplate(templateObj.href, dataObj, extra);
                    if(hrefVal){
                        $node = $('<a></a>').attr('href', hrefVal);
                    }else{
                        $node = $root;
                    }
                    break;
                case 'td':
                    $node = $('<td></td>');
                    break;
                case 'th':
                    $node = $('<th></th>');
                    break;
                case 'span':
                    $node = $('<span></span>');
                    break;
                case 'input':
                    $node = $('<input/>');
                    break;
                case 'br':
                    $node = $('<br/>');
                    break;
                    // Particular case for the switch
                case 'switch_case':
                    if(!dataObj && !extra){
                        throw 'Data object or Extra info is mandatory for a SWITCH_CASE node type';
                    }
                    var switchCaseField = this._parseTemplate(templateObj.switchCaseField, dataObj, extra);
                    // attach the corresponding content in the template
                    templateObj.content = templateObj.switchCase[switchCaseField];
                    // current root is still the root ! got it ?
                    $node = $root; 
                    break;
                default:
                    throw 'Given nodeType value [' + templateObj.nodeType + '] is unknown';
            }
            
            // Common to all nodes : attributes, classes, data...
            this._commonConversion(templateObj, dataObj, extra, $node);
            
            if(templateObj.content && typeof templateObj.content !== 'object' && !Array.isArray(templateObj.content) ){
                $node.html(this._parseTemplate(templateObj.content, dataObj, extra));
            }else{
                // Recursive call
                templateObj.content && this._convertTemplate(templateObj.content, $node, dataObj, extra);
            }
    
            $root.append($node);
        }
    };
    
    /**
     * Fills all common attributes (classes, attributes, data,...).
     */
    JsonToHtmlConverter.prototype._commonConversion = function(templateObj, dataObj, extra, $node){
        // Copy attributes
        if(templateObj.attributes){
            for(var attribute in templateObj.attributes){
                var value = this._parseTemplate(templateObj.attributes[attribute], dataObj, extra);
                if(value){
                    $node.attr(attribute, value);
                }
            }
        }
        // Copy data
        if(templateObj.data){
            for(var data in templateObj.data){
                var value = this._parseTemplate(templateObj.data[data], dataObj, extra);
                if(value){
                    $node.attr('data-' + data, value);
                }
            }
        }
        // Copy classes
        if(templateObj.classes){
            for (var i = 0, aClass; aClass = templateObj.classes[i]; i++){
                var value = this._parseTemplate(aClass, dataObj, extra);
                if(value){
                    $node.addClass(value);
                }
            }
        }
        
        // Copy ID
        if(templateObj.id){
            var value = this._parseTemplate(templateObj.id, dataObj, extra);
            if(value){
                $node.attr('id', value);
            }
        }
        
        // Copy title
        if(templateObj.title){
            $node.attr('title', this._parseTemplate(templateObj.title, dataObj, extra));
        }
    };
    
    /**
     * Replace all ${xxx} occurrences with their value from the given dataObj
     * @returns the template filled with data values. 
     */
    JsonToHtmlConverter.prototype._parseTemplate= function(attribute, dataObj, extra){
        // No data and no extra, template remains unchanged
        if(!dataObj && !extra){
            return attribute;
        }
        
        var expressions = attribute.match(this.CONSTANTS.get('EXPRESSION_REGEX')); // [ "${field1}", "${field2}", ...]
        
        if(expressions){
            for (var i = 0, expression; expression = expressions[i]; i++){
            	var exprs = this._extractExpression(expression).split('.');
                var val = dataObj;
                
                for (var j = 0; val && j < exprs.length; j++) {
                	val = val[exprs[j]];
                }
                // Could be 0 so don't use the classic if(val)... well you can try if you're looking for a new job !  
                if( val === undefined || val === null){
                    // try to find 
                    val = extra && extra[this._extractExpression(expression)];
                    if(val === undefined || val === null){
                        val = '';
                    }
                }
                attribute = attribute.replace( expression,  val);
            }
        }
        return attribute;
    }
    
    JsonToHtmlConverter.prototype._extractExpression= function(expression){
        return expression.replace( this.CONSTANTS.get('EXPRESSION_WRAPPER_REGEX'), '');
    }
    
    return JsonToHtmlConverter;
});
